import { createSlice } from '@reduxjs/toolkit';
import { addExtraReducer } from '../../utils/addExtraReducer';
import initialState from './initialState';
import {
  ClearCigarPerformanceReducer,
  GetCigarPerformanceReducer,
  GetPayrollReducer,
  GetPayrollWarningsReducer,
} from './reducers';
import { GetCigarPerformance, GetPayroll, GetPayrollWarnings } from './thunks';

// ----------------------------------------------------------------------------

// slice
export const slice = createSlice({
  name: 'cigarPerformance',
  initialState,
  reducers: {
    ClearCigarPerformance: ClearCigarPerformanceReducer,
  },
  extraReducers: (builder) => {
    addExtraReducer(builder, GetCigarPerformance, GetCigarPerformanceReducer);
    addExtraReducer(builder, GetPayroll, GetPayrollReducer);
    addExtraReducer(builder, GetPayrollWarnings, GetPayrollWarningsReducer);
  },
});

export default slice.reducer;
